import { io } from 'socket.io-client';
import { CommandBusBuilder, MemoryCommandStorage, debugBus } from '@beefco/bus';
import { devToProjectRelayFilter, processFilter, projectToGuiRelayFilter } from "./filter";
import { BusSources } from "./sources";

// FIXME: bus must be a singleton
export var createProjectBeefBus = function createProjectBeefBus(wsClientBroker, frameBroker) {
  var busFactory = new CommandBusBuilder(BusSources.PROJECT).buildRelay(BusSources.PLATFORM_GUI, function (builder) {
    return builder.withBroker(frameBroker).withStorage(new MemoryCommandStorage()).withRegistry(projectToGuiRelayFilter);
  });

  // TODO: В будущем может потребоваться запустить 'development' сборку без HMR.
  //   В этом случае проверка не пройдет и нужно будет прокинуть engine через meta-тег
  if (process.env.NODE_ENV !== 'production') {
    var socket = io({
      path: '/beef-dev-server'
    });
    wsClientBroker.connect(socket);
    busFactory.buildRelay(BusSources.DEV_SERVER, function (builder) {
      return builder.withBroker(wsClientBroker).withStorage(new MemoryCommandStorage()).withRegistry(devToProjectRelayFilter);
    });
  }
  return debugBus(busFactory.build());
};
export var createExpressBeefBus = function createExpressBeefBus(wsBroker, processBroker) {
  var busFactory = new CommandBusBuilder(BusSources.DEV_SERVER).buildRelay(BusSources.PROJECT, function (builder) {
    return builder.withBroker(wsBroker).withStorage(new MemoryCommandStorage()).withRegistry(devToProjectRelayFilter);
  });
  busFactory.buildRelay(BusSources.TS_FORK_PROCESS_PARENT, function (builder) {
    return builder.withBroker(processBroker).withStorage(new MemoryCommandStorage()).withRegistry(processFilter);
  });
  return debugBus(busFactory.build());
};
export var createProcessBus = function createProcessBus(processBroker) {
  return new CommandBusBuilder(BusSources.TS_FORK_PROCESS_CHILD).buildRelay(BusSources.TS_FORK_PROCESS_PARENT, function (builder) {
    return builder.withBroker(processBroker).withStorage(new MemoryCommandStorage()).withRegistry(processFilter);
  }).build();
};